import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Chip,
} from "@mui/material";
import earthquakeIcon from "../../../assets/images/earthquake.png";
import floodIcon from "../../../assets/images/flood.png";
import hurricaneIcon from "../../../assets/images/hurricane.png";
import tsunamiIcon from "../../../assets/images/tsunami.png";

const PREFIX = 'ResultCard';

const classes = {
  root: `${PREFIX}-root`,
  media: `${PREFIX}-media`,
  chips: `${PREFIX}-chips`,
  chip: `${PREFIX}-chip`,
  chipInverse: `${PREFIX}-chipInverse`,
  hazards: `${PREFIX}-hazards`,
  hazard: `${PREFIX}-hazard`,
  hazardImage: `${PREFIX}-hazardImage`,
  hazardTitle: `${PREFIX}-hazardTitle`,
  cardActions: `${PREFIX}-cardActions`,
  content: `${PREFIX}-content`,
  cardTitleContainer: `${PREFIX}-cardTitleContainer`,
  cardTitle: `${PREFIX}-cardTitle`
};

const StyledCard = styled(Card)((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    minWidth: "15rem",
    maxWidth: "18rem",
    margin: "0.5em",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  [`& .${classes.media}`]: {
    height: "19em",
  },

  [`& .${classes.chips}`]: {
    display: "flex",
    flexWrap: "wrap",
  },

  [`& .${classes.chip}`]: {
    border: "1px solid #e9e9e9",
    background: "#fff",
    color: "#757575",
    margin: "0.2em",
    textTransform: "capitalize",
  },

  [`& .${classes.chipInverse}`]: {
    background: "#999999",
    color: "#fff",
    margin: "0.2em",
    textTransform: "capitalize",
  },

  [`& .${classes.hazards}`]: {
    display: "flex",
    flexWrap: "wrap",
    margin: "0.5em 0 0 0",
  },

  [`& .${classes.hazard}`]: {
    display: "grid",
    margin: "0.5em 1em 0 0",
  },

  [`& .${classes.hazardImage}`]: {
    height: "1.6em",
    margin: "auto",
  },

  [`& .${classes.hazardTitle}`]: {
    fontSize: "0.8rem",
    color: "#757575",
    textTransform: "capitalize",
  },

  [`& .${classes.cardActions}`]: {
    padding: "0px 8px 8px 8px",
    display: "none",
  },

  [`& .${classes.content}`]: {
    padding: "8px 16px 16px 16px",
  },

  [`& .${classes.cardTitleContainer}`]: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    margin: "0.5em 0",
  },

  [`& .${classes.cardTitle}`]: { fontSize: "1.2rem" }
}));

const api = process.env.REACT_APP_API;
const defaultResultCardImage = process.env.REACT_APP_DEFAULT_THUMBNAIL;

const ResultCard = ({
  id,
  name,
  hazard,
  analysisType,
  type,
  date,
  scale,
  image,
}) => {

  const history = useHistory();

  const hazardIcons = {
    earthquake: earthquakeIcon,
    flood: floodIcon,
    hurricane: hurricaneIcon,
    tsunami: tsunamiIcon,
  };

  const Hazard = ({ name, image }) => {
    return (
      <div className={classes.hazard}>
        <img src={image} alt={name} className={classes.hazardImage} />
        <span className={classes.hazardTitle}>{name}</span>
      </div>
    );
  };

  const openStudy = () => {
    history.push(`/details?id=${id}`);
  };

  return (
    <StyledCard className={classes.root}>
      <CardActionArea onClick={openStudy}>
        {image !== null ? (
          <CardMedia
            className={classes.media}
            image={`${api}${image}`}
            title={`Go to ${name}`}
          />
        ) : (
          <CardMedia
            className={classes.media}
            image={defaultResultCardImage}
            title={`Go to ${name}`}
          />
        )}
        <CardContent className={classes.content}>
          <div className={classes.cardTitleContainer}>
            <span className={classes.cardTitle}>{name ? name : ""}</span>
          </div>
          <div className={classes.chips}>
            {scale ? (
              <Chip
                label={scale}
                size="small"
                className={classes.chipInverse}
              />
            ) : (
              ""
            )}
            {date ? (
              <Chip
                label={date.toString()}
                size="small"
                className={classes.chip}
              />
            ) : (
              ""
            )}
            {analysisType
              ? analysisType.map((item) => {
                  return (
                    <Chip label={item} size="small" className={classes.chip} />
                  );
                })
              : ""}
          </div>
          <div className={classes.hazards}>
            {hazard
              ? hazard.map((haz, index) => {
                  return (
                    <Hazard name={haz} image={hazardIcons[haz]} key={index} />
                  );
                })
              : ""}
          </div>
        </CardContent>
      </CardActionArea>
      <CardActions className={classes.cardActions}>
        <Button size="small" color="primary" onClick={openStudy}>
          View
        </Button>
      </CardActions>
    </StyledCard>
  );
};

export default ResultCard;
